module.exports = {"210304001":"友好街道","210304004":"双山街道","210304006":"立山街道","210304008":"曙光街道","210304009":"灵山街道","210304014":"深沟寺街道","210304015":"沙河街道","210304017":"千山街道","210304019":"齐大山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210304.json
// module id = 615
// module chunks = 0